<template>
  <div style="position: relative">
    <div class="tips" v-show="isShow">
      <div @click="downLoad" v-if="xaizai">
        <img src="../../../../../static/images/downloadicon.png" alt="">
        下载
      </div>
      <div @click="operationFn">
        <img src="../../../../../static/images/yulanicon.png" alt="">
        预览
      </div>
    </div>
    <slot></slot>

    <video-preview :videoSrc="videoSrc" :videoName="videoName" v-if="videoSrc" @closeFn="closeVideoPreview"></video-preview>
    <!-- 图片预览 -->
    <imgView v-if="imgSrc" :imgSrc="imgSrc" :imgName="imgName" @closeFn="closeImgview"></imgView>
    <!-- MP3预览 -->
    <audioView ref='audio' :audioSrc="audioSrc" :audioName="audioName" v-if="audioSrc" @closeFn="closeaudioView"></audioView>
  </div>
</template>
<script>
import videoPreview from "../../components/videoPreview.vue"
import imgView from "../../new_course_module/editCourse/sourceMaterial/imgView.vue";
import audioView from "../../new_course_module/editCourse/sourceMaterial/audioView";
export default {
  name: 'ToolTip',
 components: {
      videoPreview,
      imgView,
      audioView
  },
  props: {
   isShow:{
     type: Boolean,
     default:()=> false
   },
   href:{
     type: String,
     default: '',
     required: true,
   },
   name:{
     type: String,
     default: '',
     required: true,
   },
   type:{
     type: [Number,String],
     required: true,
   },
    id: {
     type: [Number, String]
    },
    xaizai:{
      type:Boolean,
      default: true
    }
  },
  data(){
    return {
      videoSrc: '',
      videoName: '',
      imgSrc: '',
      imgName: '',
      audioSrc: "",
      audioName: "",
    }
  },
  methods: {
    downLoad(id){
      let url = `${process.env.UPLOAD_NAME}/file/szrt/download/homeworkAttachment?id=`+ this.id
      this.$downloadFun(url)
    },
      // 文件类型（1ppt，2文档（包含word和pdf）, 3音频，4视频，5链接，6图文，7图片，8其它）
    operationFn() {// table 操作
        if(this.type==4){//视频
          this.videoSrc = this.href
          this.videoName = name
        }else if(this.type==1 || this.type==2 || this.type==8){//PPT //文档 //其他
          window.open( process.env.PREVIEW_URL + this.href )
        }else if(this.type==7){//图片
          this.imgSrc = this.href
          this.imgName = name
        }else if(this.type==3){// 音频
          this.audioSrc = this.href;
          this.audioName = name;
        }
    },

    closeVideoPreview(){//关闭视频预览
      this.videoSrc = ""
      this.videoName = ""
    },
    // 关闭图片
    closeImgview(){
      this.imgSrc = ""
      this.imgName = ""
    },
    //关闭音频预览
    closeaudioView(){
        this.audioSrc = ""
        this.audioName = ""
    },
  }
}
</script>
<style scoped lang="scss">
.tips{
  width: 110px;
  height: 34px;
  background: url('../../../../../static/images/tooltip.png')no-repeat center/100%;
  position: absolute;
  top: -34px;
  left: 50%;
  color: #fff;
  margin-left: -55px;
  display: flex;
  &>div{
    cursor: pointer;
    width: 55px;
    height: 28px;
    line-height: 28px;
    text-indent: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 12px;
    flex-direction: row;
    img{
      width: 12px;
      height: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/teachingDetail/components/ToolTip.vue